module.exports = __webpack_public_path__ + "355CC9_0_0.woff2?3fce3334eb5e4c090022ccd745aab477";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_0_0.woff2
// module id = 7
// module chunks = 0